import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@/components/ui/sonner';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { queryClient } from '@/lib/query-client';
import { router } from '@/lib/router';

/**
 * Top-level providers + router mount.
 *
 * Order matters:
 * - ErrorBoundary on the outside so a render crash anywhere in the
 *   tree falls back to the branded "Something went wrong" page
 *   instead of a white screen. The boundary doesn't catch async
 *   errors (mutation rejections, promise rejections in handlers);
 *   those are surfaced via MutationCache.onError → Sonner toasts.
 * - QueryClientProvider next so every route can use useQuery.
 * - RouterProvider owns page rendering (route-level errors fall
 *   through to `__root.tsx::defaultErrorComponent`).
 * - <Toaster /> as a sibling — Sonner mounts its own portal, so
 *   position is independent of the route tree.
 */
export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
